jQuery(function($){

  exam_new_upd_ctrl(1);
  exam_new_upd_ctrl(2);

  //検索条件の高さ取得
  var cond_height = $('.cond_box_in').outerHeight();
  if($('.cond_box').hasClass('open')) {
    $('.cond_box').css('height', cond_height+'px');
  }

  $('#btn_cond_toggle').on('click', function(event) {
    if($(this).hasClass('open')) {
      $(this).removeClass('open');
      $('.cond_box').css('height', '0');
    }else{
      $(this).addClass('open');
      $('.cond_box').css('height', cond_height+'px');
    }
  });

  //===============================================
  /* トップに戻るボタンの制御 */
  //===============================================
  var topBtn = $("#btn_pagetop");

  function view_btn_top() {
    $('body').css('overflow-x', 'hidden');
    setTimeout(function(){
      if ($(this).scrollTop() > 150) {
        topBtn.addClass('show');
      } else {
        topBtn.removeClass('show');
      }
    },100);
  }


  $('a[href^="#"]').click(function() {
    // スクロールの速度
    var speed = 400; // ミリ秒で記述
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 90;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });

  //===============================================
  /* チェックボックス全選択 */
  //===============================================
  $('#chk_all').on("click",function(){
    $('.chk').prop("checked", $(this).prop("checked"));
    disp_ctrl();
  });

  $(".chk").on('change', function () {
    disp_ctrl();
  });

  $(".num").on('focus',function(){
    $(this).select();
  });

  //===============================================
  /* ファイルinputの選択状態 */
  //===============================================
  $('.attachment .fileinput').on('change', function () {
    var file = $(this).prop('files')[0];
    $(this).closest('.attachment').find('.filename').text(file.name);
  });

  //===============================================
  /* 試験の新規・更新コントロール */
  //===============================================
  $('input[name=exam1]').on('change', function () {
    exam_new_upd_ctrl(1);
  });

  $('input[name=exam2]').on('change', function () {
    exam_new_upd_ctrl(2);
  });

  //===============================================
  /* メッセージを閉じる */
  //===============================================
  $('.btn_msg_close').on('click', function(event) {
    $(this).parent('.msg').fadeOut('fast');
  });


});

//===============================================
/* スクロールの高さ取得 */
//===============================================
function getScrollHeight(tgt, height) {
  var minusheight = window.innerHeight - height;
  $(tgt).css('height', minusheight);
}

//===============================================
/* スクロール変更 */
//===============================================
function psUpdate(obj) {
    getScrollHeight('#content', minusHeight2);
    obj.update();
}

function is_smartphone(){
  return ($(window).width() < 768);
}

//===============================================
/* 一覧コントロール部分の表示制御 */
//===============================================
function disp_ctrl() {
  if ($(".chk:checked").length > 0) {
    $('#list_ctrl').addClass('active');
  }else{
    $('#list_ctrl').removeClass('active');
  }
}

//===============================================
/* 試験の新規・更新コントロールの表示制御 */
//===============================================
function exam_new_upd_ctrl(id) {
  var val = $('.exam'+id+':checked').val();
  $('#exam'+id+'_type1,#exam'+id+'_type2').hide();
  $('#exam'+id+'_type'+val).show();
  place_opt_ctrl();
}

//===============================================
/* 会場選択肢のコントロール */
//===============================================
function place_opt_ctrl() {
  var val1 = $('input[name=exam1]:checked').val();
  var val2 = $('input[name=exam2]:checked').val();
  $('.opt_home').show();
  if(val1 == 1 || val2 == 1) {
    $('.opt_home').hide();
  }
}

